import Helper from "../Helper";
import {cartScroll} from "../cart/Cart";

/**
 * This class represents search stepping buttons that changes content.
 */
 export default class Stepper {

  /**
   * Constructor.
   *
   * @param {String} name
   */
  constructor(name) {
    this.stepper = $('[data-stepper="' + name + '"]');
    this.currentStep = 0;

    if (this.stepper.length > 0) {
		this.steps = JSON.parse(JSON.stringify(this.stepper.data('stepperSteps')));
		this.stepBack = this.stepper.find('[data-step-back]');
		this.stepForward = this.stepper.find('[data-step-forward]');
		this.viewsDestination = $('[data-view-destination="'+ this.stepper.data('viewsDestination') + '"]');

		this.stepBack.click((e) => {
			e.preventDefault();
			this.changeStep(-1);
		});

		this.stepForward.click((e) => {
			e.preventDefault();
			if(!this.stepForward.prop('disabled') && !this.stepForward.attr('disabled'))
			this.changeStep(1);
		});
    }
  }

  /**
   * This function will change current step and will take actions accordingly to a new step.
   *
   * @param {Number} takeSteps
   */
  changeStep(takeSteps) {
	  	let offset = $('[data-header-sticky]').outerHeight() + $('[data-extras]').outerHeight() + 10;

		  if (this.currentStep !== 1) {
			  Helper.scrollToElement(Helper.isMobileOrLower() ? this.viewsDestination : this.viewsDestination.parent(), offset * -1, 0, 0);
		  }

		  let nextStep = this.currentStep + takeSteps;

		if (nextStep >= 0 && nextStep < this.steps.length)
			this.currentStep = nextStep;

		let step = this.steps[this.currentStep];

		if (!step.ajax) {
			window.location = step.url;
		} else {
			if (step.type == "rooms") {
				Helper.scrollToElement(Helper.isMobileOrLower() ? this.viewsDestination : this.viewsDestination.parent(), offset * -1, 0);
				$('[data-search-submit="rooms"]').click();
				this.stepBack.addClass('hidden-mvio');
			} else {
				// If a URL has any dynamic parameters
				if (step.url.includes('{')) {
					let urlVariable = step.url.substring( step.url.lastIndexOf('{') + 1, step.url.lastIndexOf('}'));
					let variableValue = this.stepper.data(urlVariable);
					step.url = step.url.replace('{' + urlVariable + '}', variableValue);
				}

				$('[data-loader]').show();
				this.viewsDestination.hide();

				$.ajax({
					url: step.url,
					method: 'GET',
					data: {
						'_token': $('meta[name="csrf-token"]').attr('content')
					},
					dataType: 'json',
					success: (returnData) => {
					$('[data-loader]').hide();

						// If data is ok
						if(!returnData.error) {
							// Rewrite content
							this.viewsDestination.html(returnData.view);
							this.viewsDestination.show();

							this.stepBack.removeClass('hidden-mvio');
							this.stepForward.removeClass('hidden-mvio');
							if(this.currentStep === 0) this.stepBack.addClass('hidden-mvio');
							if(this.currentStep === this.steps.length - 1 ) this.stepForward.addClass('hidden-mvio');
							Helper.initFullscreenModals(document);
						} else {
							// Else this step should be skipped
							this.changeStep(takeSteps);
						}

						this.doSpecialStepActions(step.type, returnData);
						cartScroll();
					}
				});
			}
		}
  	}

  /**
   * This function will Do special actions for each step based by their type.
   * Mostly initialisations of dependencies.
   *
   * @param {String} stepType
   * @param {Object} additionalData
   */
  doSpecialStepActions(stepType, additionalData) {

    setTimeout(() => {
      window.lazyloading.appendToObserver(this.viewsDestination);

      switch(stepType) {
        case 'rooms': {
          Helper.initRoomsDependencies(this.viewsDestination, additionalData);
          break;
        }
        case 'treatments': {
          Helper.initTreatmentsDependencies(this.viewsDestination);
          break;
        }
      }
	  $('.extra_selection_tab').on('click', cartScroll);
    }, 500);
  }

  /**
   * Reset the stepper.
   */
  reset() {
    this.currentStep = 0;
  }
}
